export const REDUX = {
  AUTH_SLICE: 'auth',
  LOGIN_SUFFIX: '/login',
  REGISTER_SUFFIX: '/register',
};
